<template>
    <v-dialog :persistent="true" max-width="1200px" v-model="cDialog">
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formName)
                            }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>

                <v-card-text style="padding: 0;">
                    <c-search-form
                        :displayToolbar="false"
                        :fields="fields"
                        :rows-per-page-items="[10,20,50]"
                        :search-url="searchUrl"
                        form-type="intable"
                        key-property="materialId"
                        ref="searchTable"
                        :reload="reload"
                        :hiddenFields="hiddenFields"
                        :acceptSelect="true"
                        @selectItem="selectItem"
                        :acceptView="false"
                        :acceptDelete="false"
                        :acceptCreate="false"
                        :acceptEdit="false"
                    />
                </v-card-text>
            </v-form>
            <div style="text-align: right">
                <v-btn @click="onCancel" color="error">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.close") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import {message} from "../../../../services";
    import axios from "axios";
    import CSearchForm from "../../../../components/form/ManageForm";

    export default {
        name: "material-list",
        components: {message, axios, CSearchForm},
        props: {
            cDialog: {
                type: Boolean,
                default: false,
            },
        },
        data: () => {
            return {
                reload: 0,
                formName: "Chọn vật tư",
                inDialog: false,
                searchUrl: "/material/searchFixedAssets",
                hiddenFields: {},
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "10%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        type: "select",
                        items: [],
                        itemText: "categoryName",
                        itemValue: "categoryId",
                        name: 'typeId',
                        value: 'typeId',
                        text: 'lang.procedureWh.typeId',
                        width: "20%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: "materialCode",
                        text: "Mã vật tư",
                        width: "20%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "materialName",
                        text: 'lang.procedureWh.materialId',
                        width: "20%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "inventory",
                        text: "Tồn kho",
                        width: "10%",
                        sortable: false,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "action",
                        width: "10%",
                        text: "lang.common.actions",
                        compound: true,
                        headerStyle: "text-align:center",
                    },
                ],
            };
        },
        watch: {
            
        },
        created() {
            this.getMaterialType();
        },
        methods: {
            onCancel: function () {
                this.$emit("closeDialog", "");
            },
            getMaterialType() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE&description=1"
                )
                .then(
                    (data) => {
                        const arr1 = [{categoryId: 111, categoryName: 'Tên tài sản'}];
                        if (data.length > 0) {
                            const listType = arr1.concat(data);
                            let itemFields = this.fields.filter(function (e) {
                                return e.name == "typeId";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = listType;
                            }
                        }
                    }
                );
            },
            selectItem(item) {
                this.$emit("select", item);
            },
        },
    };
</script>